import { createSelector } from 'reselect';
import { databaseId as databaseIdSelector } from '@Selectors/StateParamsSelectors';
import { breadcrumbsReducerKey } from './BreadcrumbsConstants';

export function breadcrumbsState(state) {
  return state.get(breadcrumbsReducerKey);
}

export function breadcrumbsItems(state) {
  return breadcrumbsState(state).get('items');
}

export function breadcrumbsIds(state) {
  return breadcrumbsState(state).get('ids');
}

export function breadcrumbsActiveItemGroup(state) {
  const items = breadcrumbsState(state).get('items');
  const activeItem = items.find((item) => !!item.get('active'));
  return activeItem ? activeItem.get('groupId') : null;
}

export const breadcrumbsIdsOrdered = createSelector(
  [breadcrumbsIds, breadcrumbsItems, breadcrumbsActiveItemGroup],
  (_breadcrumbsIds, _breadcrumbsItems, _breadcrumbsActiveItemGroup) =>
    _breadcrumbsIds
      ?.filter((id) => _breadcrumbsItems.getIn([id, 'groupId']) === _breadcrumbsActiveItemGroup)
      ?.sortBy(
        (id) => _breadcrumbsItems.getIn([id, 'creationTime']),
        (a, b) => a - b
      )
);

export function isBackToQueryVisibleFn(breadcrumb) {
  return (
    !breadcrumb.get('batchSearch') &&
    ((breadcrumb.get('isHistoryBreadcrumb') &&
      (breadcrumb.get('historyType') === 'queryBuilder' || !!breadcrumb.getIn(['quickSearchItem', 'whereClauseImportToken']))) ||
      (!breadcrumb.get('isHistoryBreadcrumb') &&
        (breadcrumb.get('historyType') === 'queryBuilder' || breadcrumb.get('historyType') === 'quickSearch')))
  );
}

export function isBackToQueryBuilderFn(breadcrumb) {
  return !!breadcrumb.get('isFromAdvancedSearch');
}

export function shouldDisplayPreviewResultsBreadcrumbFn(breadcrumb) {
  return breadcrumb.get('historyType') === 'quickSearch' && !breadcrumb.get('isHistoryBreadcrumb');
}

// eslint-disable-next-line no-shadow
export const activeBreadcrumbForDb = createSelector([breadcrumbsItems, databaseIdSelector], (breadcrumbsItems, databaseId) =>
  breadcrumbsItems.find((item) => item.get('active') && item.get('databaseId') === databaseId)
);

// eslint-disable-next-line no-shadow
export const rootBreadcrumbForDb = createSelector([breadcrumbsItems, databaseIdSelector], (breadcrumbsItems, databaseId) =>
  breadcrumbsItems.find((item) => item.get('databaseId') === databaseId)
);

export const activeBreadCrumbTotalResult = createSelector([activeBreadcrumbForDb], (activeBreadCrumb) => {
  if (!activeBreadCrumb) {
    return null;
  }

  return activeBreadCrumb.get('totalResult');
});

// Patent Family Clustering
export const activeBreadCrumbRecordCount = createSelector([activeBreadcrumbForDb], (activeBreadCrumb) => {
  if (!activeBreadCrumb) {
    return null;
  }

  return activeBreadCrumb.get('recordCount');
});

export const activeBreadCrumbContext = createSelector([activeBreadcrumbForDb], (activeBreadCrumb) => {
  if (!activeBreadCrumb) {
    return null;
  }

  return activeBreadCrumb.get('context');
});
